module.exports = __webpack_public_path__ + "static/media/orders.aaebc674.svg";